<template>
  <transition name="fade" mode="out-in">
    <div v-if="_.get($store.state.main.selected_menu, 'id')" class="page-wrapper">
      <PortalTarget name="modal" multiple></PortalTarget>

      <component :is="selectedLayout" :key="selectedLayout" v-if="selectedLayout" />
    </div>
  </transition>
</template>

<script>
import mainMixin from '@/mixins/main';
import pageRouting from '@/mixins/pageRouting';
import getCardData from '@/mixins/getCardData';

export default {
  name: 'App',
  mixins: [mainMixin, pageRouting, getCardData],
  metaInfo() {
    const innerSeo = _.get(
      this.$store.state.main.current_content,
      `primary.data.list[0].seo_title_${this.$store.state.main.locale}`
    );
    const website_title = _.get(this.$store.state.main.indx, 'siteSettings.website_title');

    let contentTitle =
      innerSeo ||
      _.get(this.$store.state.main.selected_menu, 'seo.title') ||
      _.get(this.$store.state.main.selected_menu, 'title');

    if (!innerSeo && Object.values(this.$route.params).includes('singleview')) {
      contentTitle = _.get(this.$store.state.main.current_content, 'primary.data.list[0].title');
    }
    const description =
      _.get(this.$store.state.main.selected_menu, ['seo', 'description']) ||
      _.get(this.$store.state.main.indx, 'siteSettings.website_meta_description');
    const keyword =
      _.get(this.$store.state.main.selected_menu, ['seo', 'keywords']) ||
      _.get(this.$store.state.main.indx, 'siteSettings.website_meta_keywords');
    // if no subcomponents specify a metaInfo.title, this title will be used
    return {
      title:
        !this.$store.state.main.mallType &&
        this.$route.params.path1 !== 'about-us' &&
        this.$route.params.path1 !== 'card-loyal'
          ? website_title
          : contentTitle,
      // all titles will be injected into this template
      titleTemplate: '%s | ' + website_title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description,
        },
        {
          vmid: 'keyword',
          name: 'keyword',
          content: keyword,
        },
      ],
    };
  },
  data() {
    return {
      selectedLayout: '',
      popup: null,
    };
  },

  created() {
    // this.$cookies.set("_uctoken", 'slkdjsakldjsakljdskladjkslajdklsajkdlsa')
    this.req_handler();
  },
  mounted() {
    if (this.$route.name && this.$route.name.indexOf('PageViewRouter') >= 0)
      this.$store.commit('main/setState', { key: 'showSite', val: true });
  },

  watch: {
    '$store.state.cache': {
      immediate: true,
      deep: true,
      handler() {
        // console.log(111, this.$store.state.main.cache);
      },
    },
    $route: {
      immediate: true,
      deep: true,
      handler: function({ query }) {
        if (
          !this.$route.params.path1 ||
          this.$route.params.path1 == 'about-us' ||
          this.$route.params.path1 == 'card-loyal'
        ) {
          this.$store.commit('main/setState', {
            key: 'mallType',
            val: null,
          });
        } else {
          this.$store.commit('main/setState', {
            key: 'mallType',
            val: this.$route.params.path1,
          });
        }
        this.pageRoutingSelectMenuByPath();
        if (this.$route.name === 'PageViewRouter_ge') {
          document.querySelector('html').setAttribute('lang', 'ge');
        } else {
          document.querySelector('html').setAttribute('lang', 'en');
        }
        if (typeof query.success !== 'undefined') {
          this.popup = query.success == 'true' ? { successStep: true } : { errorStep: true };
        } else {
          this.popup = null;
        }
      },
    },

    '$store.state.main.selected_menu.id': {
      immediate: true,
      handler() {
        this.setLayoutTemplate();

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      },
    },

    '$store.state.main.indx.smartLayouts': {
      handler() {
        this.importLayouts();
        this.pageRoutingSelectMenuByPath();
        this.setLayoutTemplate();

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      },
    },

    info_status: {
      immediate: true,
      handler(ns) {
        if (ns === 'rejected') {
          // this.$router.push(this.loyal_card_link?.full_url);
          console.log('removetokens');
          if (this.$cookies.get('_uctoken')) {
            this.$cookies.remove('_uctoken');
          }
          if (this.$cookies.get('_uccode')) {
            this.$cookies.remove('_uccode');
          }
          if (this.$cookies.get('_logouttoken')) {
            this.$cookies.remove('_logouttoken');
          }
        }

        if (this.$route.query.code && ns === 'resolved') {
          this.$router.push(this.cabinet_page_link?.full_url);
        }
      },
    },
  },
  computed: {
    localStorageState() {
      return localStorage.getItem('mallType') || null;
    },
    info_status() {
      return this.$store.state.main.infoStatus;
    },
    loyal_card_link() {
      return this.$store.state.main.indx.menus.filter((menu) =>
        menu.configs.includes('loyal-card')
      )[0];
    },
    cabinet_page_link() {
      return this.$store.state.main.indx.menus.filter((menu) =>
        menu.configs.includes('cabinet-page')
      )[0];
    },
  },

  methods: {
    importLayouts() {
      /// dinamicaly import all layouts as components
      let components = _.get(this.$store.state.main.indx, 'smartLayouts');

      for (let i in components) {
        this.$options.components[i] = () => import('./views/layouts/' + i);
      }
      return true;
    },

    /// set layout template depend on selected_menu.currentLayoutTemplate
    setLayoutTemplate() {
      if (
        this.$options.components[
          _.get(this.$store.state.main.selected_menu, 'currentLayoutTemplate')
        ]
      ) {
        this.selectedLayout = this.$store.state.main.selected_menu.currentLayoutTemplate;
      }
    },
  },
};
</script>
<style scoped></style>
